import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { ModalModule, ModalService } from '@vinnova/ui';
import { environment } from '../../environment';

@Component({
  selector: 'lib-betalningsuppgift-reminder-modal',
  imports: [ModalModule, TranslocoModule],
  templateUrl: './betalningsuppgift-reminder-modal.component.html',
  styleUrls: ['./betalningsuppgift-reminder-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BetalningsuppgiftReminderModalComponent {
  public modalService = inject(ModalService);
  private env = inject(environment);

  goToMinProfil() {
    globalThis.location.href = `${this.env.etjansterCommonUrl}/profil`;
  }
}
